module.exports = __webpack_public_path__ + "img/footer-1-at.f503a699.png";